/* Adapter Finish Guide cards, shared by the preview and its checks. For a guide watch, each Apple
   case finish of that generation (Apple's image of the watch) with its best-suited real adapter (the
   close-up; data/adapter-guide-images.json, from the Image review's per-series close-ups). A band
   without adapter options for the watch's size shows no cards. */
(function(root,factory){
 const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.LongvadonAdapterGuide=api;
})(typeof globalThis!=='undefined'?globalThis:this,function(){
 'use strict';
 function items({data,watch,images,visualId}){
  if(!data.variants.some(v=>v.bucket===watch.bucket&&v.adapter&&v.adapter!=='—'))return [];
  return (images?.watches?.[visualId]||[]).map(card=>{
   const image=images.finishes[card.finish],watch=images.watchImages[card.watch];
   return {...card,src:image.src,width:image.width,height:image.height,watchImage:{src:watch.src,width:watch.width,height:watch.height}};
  });
 }
 return {items};
});
